import React, { FC, memo } from 'react';

import SingleFieldTab from 'components/ResqlExpert/SubmissionForm/SingleFieldTab';

const Actions: FC = () => (
  <SingleFieldTab
    fieldName="actions_taken"
    titleKey="tab_actions"
    hintKey="tab_actions_hint"
  />
);

export default memo(Actions);
